var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "none",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.00005L11.445 1.37005C11.6093 1.26042 11.8025 1.2019 12 1.2019C12.1975 1.2019 12.3907 1.26042 12.555 1.37005L21 7.00005V21.0001C21 21.2653 20.8946 21.5196 20.7071 21.7072C20.5196 21.8947 20.2652 22.0001 20 22.0001H4C3.73478 22.0001 3.48043 21.8947 3.29289 21.7072C3.10536 21.5196 3 21.2653 3 21.0001V7.00005ZM5 8.07005V20.0001H19V8.07005L12 3.40405L5 8.07005ZM8 16.0001H16V18.0001H8V16.0001ZM8 13.0001H16V15.0001H8V13.0001ZM12 11.0001C11.4696 11.0001 10.9609 10.7893 10.5858 10.4143C10.2107 10.0392 10 9.53049 10 9.00005C10 8.46962 10.2107 7.96091 10.5858 7.58584C10.9609 7.21077 11.4696 7.00005 12 7.00005C12.5304 7.00005 13.0391 7.21077 13.4142 7.58584C13.7893 7.96091 14 8.46962 14 9.00005C14 9.53049 13.7893 10.0392 13.4142 10.4143C13.0391 10.7893 12.5304 11.0001 12 11.0001Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.ea986ba56f226dd6ed64bc841c8f89a5.svg";
export { ForwardRef as ReactComponent };